/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_Openai_DescInputs */

const en_privacy_section_5_openai_desc = /** @type {(inputs: Privacy_Section_5_Openai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powers our AI chatbot assistant.`)
};

const lv_privacy_section_5_openai_desc = /** @type {(inputs: Privacy_Section_5_Openai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nodrošina mūsu AI asistenta darbību.`)
};

/**
* | output |
* | --- |
* | "powers our AI chatbot assistant." |
*
* @param {Privacy_Section_5_Openai_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_openai_desc = /** @type {((inputs?: Privacy_Section_5_Openai_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_Openai_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_openai_desc(inputs)
	return en_privacy_section_5_openai_desc(inputs)
});